export default "__VITE_ASSET__CwFHXAo___"